// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { SkillState } from "@/types/skill";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Skill } from "@/models/skill";

const state: SkillState = {
  single: new Skill(),
  pagination: new Pagination(),
};

export const skill: Module<SkillState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
